<template>
  <header class="logo-header" :class="centerLayoutClass">
    <div class="logo-header__banxa">
      <LogoBanxa v-if="!shouldHideLogo" />
      <SettingsOpenButton />
    </div>
    <template v-if="shouldShowMerchantLogo && !shouldHideLogo">
      <div class="logo-header__divider"></div>
      <div class="logo-header__partner">
        <img
          :src="merchantLogo"
          :alt="`${merchantSettings.name} partner logo`"
        />
      </div>
    </template>
  </header>
</template>

<script setup>
import { computed } from "vue";
import { useGlobalStore } from "@/stores/globalStore";
import { useOrderFormStore } from "@/stores/forms/orderFormStore";
import SettingsOpenButton from "@/components/ui/buttons/SettingsOpenButton.vue";
import LogoBanxa from "@/components/images/LogoBanxa.vue";

const store = useGlobalStore();
const orderStore = useOrderFormStore();
const merchantSettings = computed(() => store.global.merchant);
const shouldShowMerchantLogo = computed(() => store.global.merchant?.logo || store.global.merchant?.theme?.dark_logo || store.global.merchant?.theme?.light_logo);
const merchantLogo = computed(() => {
  if (store.global.merchant?.theme?.dark_logo && store.getIsDarkMode){
    return store.global.merchant.theme.dark_logo;
  }
  if (store.global.merchant?.theme?.light_logo && store.getIsLightMode){
    return store.global.merchant.theme.light_logo
  }
  return store.global.merchant?.logo
})
const shouldHideLogo = computed(() => store.getIsGreyLabel);
const centerLayoutClass = computed(() => {
  if (store.getIsGreyLabel) {
    return "grey-label";
  }
  if (orderStore.isNFTMode) {
    return "nft-layout"
  }
  return "";
});
</script>

<style lang="scss">
.logo-header {
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 5rem 0 2.8rem;

  @include breakpoint($min-m) {
    padding-top: 6rem;
  }

  > div img {
    max-width: 8rem;

    @include breakpoint($min-m) {
      max-width: 10rem;
    }
  }

  &__divider {
    height: 1.9rem;
    width: 1px;
    background: rgba($white, 0.2);
    margin: 0 3rem;
  }

  & .settings-btn {
    display: block;
    position: absolute;
    top: 0;
    left: 105%;
    transform: translate(-100%);
    margin-top: var(--padding-1);
    margin-left: calc(-1 * var(--padding-1));
    transition: opacity 500ms ease-in-out;

    @include breakpoint($min-m) {
      display: none;
    }
  }
}

.logo-header.grey-label {
  padding-top: 6rem;
  padding-bottom: 0;
  order: 2;
  max-width: 0px;

  @include breakpoint($min-m) {
    padding-bottom: 2.8rem;
  }

  & .settings-btn {
    display: block;
    position: absolute;
    top: 0;
    left: 100%;
    transform: translate(-100%);
    margin-top: var(--padding-1);
    margin-left: calc(-1 * var(--padding-1));
    transition: opacity 500ms ease-in-out;
  }
}

.logo-header.nft-layout {
  justify-content: left;
  padding-left: 5rem;

  & .settings-btn {
    display: block;
    position: absolute;
    top: 0;
    left: 100%;
    transform: translate(-100%);
    margin-top: var(--padding-1);
    margin-left: calc(-1 * var(--padding-1));
    transition: opacity 500ms ease-in-out;
  }
}
</style>
